import React, { FC } from 'react';
import useLocale from '@/hooks/useLocale';
import {
  getSkuString,
  getReviewsWidgetId,
  getShortRatingsWidgetId,
  getLongRatingsWidgetId,
} from '@/utils/trustedShopsHelpers';
import { ShopifyProduct } from '@/lib/shopify';

export interface TrustedShopsReviewsProps {
  shopifyProduct: ShopifyProduct | null | undefined;
  widgetType: 'reviews' | 'ratings-short' | 'ratings-long';
}

const TrustedShopReviews: FC<TrustedShopsReviewsProps> = ({
  shopifyProduct,
  widgetType,
}) => {
  const locale = useLocale();

  const getWidgetIdFunctionMap = {
    reviews: getReviewsWidgetId,
    'ratings-short': getShortRatingsWidgetId,
    'ratings-long': getLongRatingsWidgetId,
  };

  let widgetId = null;
  const getWidgetIdFunction = getWidgetIdFunctionMap[widgetType];
  if (getWidgetIdFunction) {
    widgetId = getWidgetIdFunction(locale);
  } else {
    console.warn(
      `Could not get Trusted Shop widgetId. Widget type '${widgetType}' does not have an associated function to fetch the ID.`,
    );
    return null;
  }

  const skuString = getSkuString(shopifyProduct);

  return (
    <div
      dangerouslySetInnerHTML={{
        __html: `
          <etrusted-widget
            data-etrusted-widget-id="${widgetId}"
            ${skuString ? `data-sku="${skuString}"` : ''}
          />
        `,
      }}
    ></div>
  );
};

export default React.memo(TrustedShopReviews);
